import { UtilityService } from '@app/services/utility/utility.service';
import { ContentModel } from '@app/models/content-data';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent {
    @Input() props: ContentModel = new ContentModel();

    constructor(public utilityService: UtilityService) {}
}
